import clsx from "clsx";
import { FC, HTMLAttributes, PropsWithChildren } from "react";

export interface ErrorMessageProps {
  /**
   * @deprecated use `children` instead
   */
  errorMessage?: string;
}

const ErrorMessage: FC<
  PropsWithChildren<ErrorMessageProps & HTMLAttributes<HTMLParagraphElement>>
> = ({ errorMessage, className, children, ...props }) => {
  return (
    <p
      {...props}
      className={clsx("mt-xs text-title-1 text-error-700", className)}
    >
      {errorMessage || children}
    </p>
  );
};

export default ErrorMessage;
